<template lang="pug">
Page.developer-edit
    .developer-edit__top(
        slot="header"
    )
        h1.developer-edit__title
            | Создание застройщика

        SvMenu(
            @copy="copy"
            @remove="remove"
        )

    SvTabs.developer-edit__table(
        v-model="currentTab"
        :tabs="['Основное', 'О компании', 'SEO']"
    )
        .developer-edit__actions
            SvButton.developer-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.developer-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.developer-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )
    keep-alive
        .developer-form-wrapper(
          v-if="currentTab === 0"
        )
          .developer-edit__form
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Активность
                .developer-edit__form-elements--small.radio
                    SvRadio.developer-edit__form-radio(
                        v-model="is_active"
                        :value="true"
                        label="Да"
                    )
                    SvRadio.developer-edit__form-radio(
                        v-model="is_active"
                        :value="false"
                        label="Нет"
                    )

            .developer-edit__form-item
                span.developer-edit__form-title
                    | Скрыть лого застройщика
                .developer-edit__form-elements--small.radio
                    SvCheckbox.developer-edit__form-elements--small(
                      v-model="no_developer_logo"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Название
                .developer-edit__form-elements--small
                    SvInput(
                        v-model="name"
                        color="graylight"
                        placeholder="Например: СибирьИнвест"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Символьный код
                .developer-edit__form-elements--small
                    SvInput(
                        v-model="alias"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | % сданных объектов в срок
                .developer-edit__form-elements--small
                    SvInput(
                        mask="numeric"
                        v-model="passed_objects_percent"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Кол-во сданных домов
                .developer-edit__form-elements--small
                    SvInput(
                        mask="numeric"
                        v-model="passed_objects_count"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Год основания
                .developer-edit__form-elements--small
                    SvInput(
                        mask="numeric"
                        v-model="year_foundation"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Домов в стройке
                .developer-edit__form-elements--small
                    SvInput(
                        mask="numeric"
                        v-model="in_work_objects_count"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Строительство по (214 фз)
                .developer-edit__form-elements--small
                    SvInput(
                        v-model="completion_to"
                        placeholder="Например: jiloy-complex"
                        color="graylight"
                        :withIcon="false"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Логотип
                .developer-edit__form-elements--small
                    SvUpload(
                        v-model="logo"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Логотип белый
                .developer-edit__form-elements--small
                    SvUpload(
                        v-model="logo_white"
                    )
            .developer-edit__form-item
                span.developer-edit__form-title
                    | Изображение о компании
                .developer-edit__form-elements--small
                    SvUpload(
                        v-model="picture_about"
                    )
    keep-alive
        FormDeveloperAbout(
            v-if="currentTab === 1"
        )
        FormDeveloperSeo(
            v-if="currentTab === 2"
        )

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import FormDeveloperAbout from '@/components/forms/FormDeveloperAbout.vue';
import FormDeveloperSeo from '@/components/forms/FormDeveloperSeo.vue';
import { rusToLatin } from '@/helpers/transform';

export default {
  name: 'DeveloperEdit',

  data() {
    return {
      currentTab: 0,
    };
  },

  beforeMount() {
    this.$store.dispatch('developer/getById', this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('developer/getById', to.params.id);
    }
    next();
  },

  mounted() {
    // console.log('developer edit mounted')
  },

  computed: {
    ...mapGetters({
      current: 'developer/getCurrent',
    }),

    no_developer_logo: {
      get() {
        return Boolean(this.current.no_developer_logo);
      },
      set(no_developer_logo) {
        this.setValue({ no_developer_logo });
      },
    },

    is_active: {
      get() {
        return Boolean(this.current.is_active);
      },
      set(is_active) {
        this.setValue({ is_active });
      },
    },

    name: {
      get() {
        return this.current.name;
      },
      set(name) {
        this.setValue({ name });
        this.setValue({ alias: rusToLatin(name) });
      },
    },

    alias: {
      get() {
        return this.current.alias;
      },
      set(alias) {
        this.setValue({ alias });
      },
    },

    passed_objects_percent: {
      get() {
        return this.current.passed_objects_percent;
      },
      set(passed_objects_percent) {
        this.setValue({ passed_objects_percent });
      },
    },

    passed_objects_count: {
      get() {
        return this.current.passed_objects_count;
      },
      set(passed_objects_count) {
        this.setValue({ passed_objects_count });
      },
    },

    year_foundation: {
      get() {
        return this.current.year_foundation;
      },
      set(year_foundation) {
        this.setValue({ year_foundation });
      },
    },

    in_work_objects_count: {
      get() {
        return this.current.in_work_objects_count;
      },
      set(in_work_objects_count) {
        this.setValue({ in_work_objects_count });
      },
    },

    completion_to: {
      get() {
        return this.current.completion_to;
      },
      set(completion_to) {
        this.setValue({ completion_to });
      },
    },

    logo: {
      get() {
        return this.current.logo;
      },
      set(logo) {
        this.setValue({ logo });
      },
    },

    logo_white: {
      get() {
        return this.current.logo_white;
      },
      set(logo_white) {
        this.setValue({ logo_white });
      },
    },

    picture_about: {
      get() {
        return this.current.picture_about;
      },
      set(picture_about) {
        this.setValue({ picture_about });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'developer/setValue',
    }),

    resetForm() {
      this.$store.commit('developer/clearCurrent');
      this.$router.push({ name: 'developers' });
    },

    copy() {
      this.$store.commit('developer/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({ name: 'developer-edit', params: { id: 'new' } });
    },

    async remove() {
      await this.$store.dispatch('developer/remove', this.$route.params.id);
      this.$router.push({ name: 'developers' });
    },

    async save(isRedirect = false) {
      const id = await this.$store.dispatch('developer/save');
      console.log('save -> id', id);
      if (!isRedirect) {
        this.$router.push({
          name: 'developer-edit',
          params: {
            id,
          },
        }).catch((err) => {
          console.log(err);
        });
      } else {
        this.$router.push({ name: 'developers' });
      }
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvCheckbox,
    SvUpload,
    FormDeveloperAbout,
    FormDeveloperSeo,
  },
};
</script>

<style lang="scss" scoped>
.developer-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.developer-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.developer-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.developer-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.developer-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.developer-edit__form {
    padding: 50px 0;
}

.developer-edit__form-radio {
    margin-right: 21px;
}

.developer-edit__form-elements--medium {
    width: 495px;
}

.developer-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.developer-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
